import { render, staticRenderFns } from "./EncodingCreate.vue?vue&type=template&id=4c06c491&scoped=true"
import script from "./EncodingCreate.vue?vue&type=script&lang=js"
export * from "./EncodingCreate.vue?vue&type=script&lang=js"
import style0 from "./EncodingCreate.vue?vue&type=style&index=0&id=4c06c491&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c06c491",
  null
  
)

export default component.exports